export class RqlParser {
    // Maps of types per variable
    variableTypes: Map<string, string[]>;

    constructor() {
        this.variableTypes = new Map<string, string[]>();
    }

    parse(query: string) {
        // console.log(this.variableTypes);
        this.variableTypes = new Map<string, string[]>();

        // Retrieve all triples starting with "ANYVARIABLE is SomeType"
        const typeTriples = Array.from(
            query.matchAll(/([A-Z]+) is ([A-Z][A-Za-z]+)/g)
        );
        typeTriples.forEach((triple) => {
            if (this.variableTypes.has(triple[1])) {
                this.variableTypes.get(triple[1])!.push(triple[2]);
            } else {
                this.variableTypes.set(triple[1], [triple[2]]);
            }
        });
    }

    getVariableType(variable: string) {
        // if at least one triple has the shape "variable is AGivenType"
        if (this.variableTypes.has(variable)) {
            // If more than one, return only the first one
            // return AGivenType
            return this.variableTypes.get(variable)![0];
        }

        //else return null
        return null;
    }
}
